import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'

import { withTranslation } from 'react-i18next'

import BankStatementImportPaymentConfirms from '../../components/BankStatements/ImportPaymentConfirms'

import actions from '../../redux/bankStatements/actions'
import notificationActions from '../../redux/notifications/actions'

const { setImportPaymentConfirmsVisibleModal, uploadBankStatementPaymentConfirms } = actions
const { setNotifications } = notificationActions

class BankStatementImportPaymentConfirmsContainer extends Component {
    static propTypes = {
        // Inner Props
        bankStatements: ImmutablePropTypes.map.isRequired,
        setImportPaymentConfirmsVisibleModal: PropTypes.func.isRequired,
        setNotifications: PropTypes.func.isRequired,
        uploadBankStatementPaymentConfirms: PropTypes.func.isRequired
    }

    static defaultProps = {}

    onSubmit = ({ params = {} } = {}) => {
        const { i18n, uploadBankStatementPaymentConfirms, setNotifications } = this.props

        uploadBankStatementPaymentConfirms({
            params,
            onSuccess: () => {
                this.onToggleVisibleModal()
                setNotifications(
                    i18n.t('bankStatements:uploadSuccess'),
                    i18n.t('bankStatements:uploadSuccessDescription'),
                    'info'
                )
            },
            onError: () => {
                setNotifications('error', 'error', 'error')
            }
        })
    }

    onToggleVisibleModal = () => {
        const { bankStatements, setImportPaymentConfirmsVisibleModal } = this.props

        setImportPaymentConfirmsVisibleModal({
            visibleModal: !bankStatements.getIn(['importPaymentConfirms', 'visibleModal'], true)
        })
    }

    render () {
        const { bankStatements } = this.props

        return (
            <BankStatementImportPaymentConfirms
                visibleModal={bankStatements.getIn(['importPaymentConfirms', 'visibleModal'], false)}
                saving={bankStatements.get('saving', false)}
                onSubmit={this.onSubmit}
                onToggleVisibleModal={this.onToggleVisibleModal}
            />
        )
    }
}

const mapStateToProps = (state) => {
    return {
        bankStatements: state.get('bankStatements')
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        setImportPaymentConfirmsVisibleModal,
        setNotifications,
        uploadBankStatementPaymentConfirms
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(
    withTranslation(['bankStatements'])(BankStatementImportPaymentConfirmsContainer)
)
